import { z } from "zod";

/**
 * Transfer mode.
 * - `cold`: blind redirect — the caller is dialed straight to the target and the AI session ends.
 * - `warm`: the caller stays with the AI while the target is reached and briefed with a summary,
 *   then both are bridged in a conference once the target accepts; if the target is unreachable
 *   the caller returns to the AI.
 */
export const PHONE_CALL_TRANSFER_MODES = ["cold", "warm"] as const;
export const PhoneCallTransferModeSchema = z.enum(PHONE_CALL_TRANSFER_MODES);
export type PhoneCallTransferMode = z.infer<typeof PhoneCallTransferModeSchema>;

/**
 * Call transfer configuration
 */
export const PhoneCallTransferSchema = z.object({
  name: z.string(),
  description: z.string(),
  to: z.string(),
  summaryDescription: z.string(),
  /** Transfer strategy for this target. Defaults to `cold` so existing configs are unchanged. */
  mode: PhoneCallTransferModeSchema.default("cold")
});

export type PhoneCallTransfer = z.infer<typeof PhoneCallTransferSchema>;
